//import { MatSelectChange } from "@angular/material";
import { Component, OnInit, Inject } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MatDialogRef,
  MAT_DIALOG_DATA,
  MatDialog
} from "@angular/material/dialog";

import * as moment from "jalali-moment";
import { SoundEnum } from "src/app/enums/sound.enum";
import { IConfirm } from "src/app/interfaces/confirm";
import { TranslateService } from "@ngstack/translate";
import { ErrorsService } from "src/app/services/common/errors.service";
import { SnackBarService } from "src/app/services/common/snackBar.service";
import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { IDiscountGroupByTermInfo } from "src/app/interfaces/discountGroup-byTermInfo";
import { CourseService } from "./../../../../services/http/business/course/course.service";
import { DiscountGroupService } from "src/app/services/http/business/discount-group/discount-group.service";
import { ExceptionalCoefficientsService } from "src/app/services/http/business/ExceptionalCoefficients/exceptional-coefficients.service";
import { BIDService } from "src/app/services/common/bid.service";
import { environment } from "src/environments/environment";
import { StaticValueService } from "../../../../services/http/business/staticValue/static-value.service";
import { IError } from "src/app/interfaces/error.interface";

@Component({
  selector: 'app-edit-course-entry',
  templateUrl: './edit-course-entry.component.html',
  styleUrls: ['./edit-course-entry.component.css']
})
export class EditCourseEntryComponent implements OnInit {

  form: FormGroup;
  termName: string;
  roomTitle: string;
  room: any;
  branchName: string;
  courseTypeName: string;
  minDate: any;
  maxDate: any;
  courseTime: any;
  startDate: any;
  hideTeacher: boolean = true;
  hidePicker: boolean = true;
  sexualityName: any;
  sexualityId: number;
  sexualities: any;
  levelInfoId: number;
  teachersList: [{}];
  coursePatternList = [];
  discountGroupList: IDiscountGroupByTermInfo[];
  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];
  showGender: boolean = true;
  firstDate: any;
  endDate: any;
  levelCapacity: number;
  coefficient: any;

  constructor(
    private fb: FormBuilder,
    private dialog: MatDialog,
    private snackBar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    private staticValueService: StaticValueService,
    private courseService: CourseService,
    private discountGroupService: DiscountGroupService,
    private exceptionalCoefficientsService: ExceptionalCoefficientsService,
    private bidService: BIDService,
    private dialogRef: MatDialogRef<EditCourseEntryComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    this.createForm();
    this.loadDiscountGroup();
    this.getCoefficient();
    this.getSexuality();
  }

  createForm() {
    this.form = this.fb.group({
      Id: [this.data.Id],
      DiscountGroupId: [this.data.DiscountGroupId],
      CourseStatusId: [10],
      SexualityId: [null],
      OnlineCourseLink: [this.data.CourseDetails.OnlineCourseLink],
      CapacityFree: [
        this.data.CapacityFree,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(100)
        ])
      ],
      CapacityFreeOnline: [
        this.data.CapacityFreeOnline,
        Validators.compose([
          Validators.required,
          Validators.min(0),
          Validators.max(100)
        ])
      ],
      IsAsset: [this.data.IsAsset]
    });

    

    this.form.controls["CourseStatusId"].setValue(this.data.CourseDetails.CourseStatusId.toString());
    this.form.controls["SexualityId"].setValue(this.data.CourseDetails.SexualityId.toString());

    if (this.data.CourseDetails.OnlineCourseLink)
      this.form.controls["OnlineCourseLink"].setValue(this.data.CourseDetails.OnlineCourseLink.toString());

  }

  getCoefficient() {
    let coefficientModel = {
      BranchEncryptId: this.bidService.getBID(),
      CoursePatternId: this.data.CourseDetails.CoursePatternId,
      LevelInfoId: this.data.CourseDetails.LevelInfoId,
      TimeStart: this.data.CourseDetails.StartTime,
      TimeEnd: this.data.CourseDetails.Session[0].EndTime
    }
    this.exceptionalCoefficientsService.getCoefficient(coefficientModel).subscribe(res => {
      this.coefficient = res.TotalCoefficient;
    }, err => {
      // this.errObject = this.errorService.getError(err);
      // this.param = this.errorService.objectError(this.errObject);
      // this.errors = this.errorService.returnError(err);
      this.errorList = this.errorService.getErrorList(err.error);
    })
  }

  getSexuality() {
    this.staticValueService.genderType(false).subscribe(
      res => {
        this.sexualities = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  loadDiscountGroup() {
    var data: IDiscountGroupByTermInfo = {
      LevelInfoId: this.data.CourseDetails.LevelInfoId,
      CoursePatternId: this.data.CourseDetails.CoursePatternId,
      TimeFrom: this.data.CourseDetails.StartTime
    };
    this.discountGroupList = [];
    this.discountGroupService
      .listByLevelInfoAndCoursePattern(data)
      .subscribe(res => {
        this.discountGroupList = res;
      });
  }

  submitCourse(form: any) {
    this.errors = new Array();
    if (form.DiscountGroupId == 0)
      form.DiscountGroupId = null;
    this.courseService.edit(form).subscribe(
      () => {
        this.dialogRef.close(form);
        this.snackBar.OpenSnackBar(
          this.translate.get("success.registration"),
          "ok",
          5000,
          SoundEnum.beep
        );
      },
      err => {
        this.errObject = this.errorService.getError(err);
        this.param = this.errorService.objectError(this.errObject);
        this.errors = this.errorService.returnError(err);
        this.errorList = this.errorService.getErrorList(err.error);
        if (+this.errors == 13038) {
          let confirm: IConfirm = {
            accept: true,
            message: this.translate.get("serviceErrors.13038", {
              param1: this.param[1]
            }),
            alert: null,
            yesLabel: this.translate.get("label.yes"),
            noLabel: this.translate.get("label.no")
          };
          this.dialog
            .open(ConfirmComponent, {
              width: "250px",
              data: confirm
            })
            .afterClosed()
            .subscribe(res => {
              if (res) {
                this.errors = new Array();
                this.courseService.fire();
                form.StartDate = moment
                  .from(form.StartDate, "en")
                  .utc(true)
                  .format(environment.dateFormat);
                //form.SexualityId = +this.sexualityId;
                form.RoomCapacity = false;
                this.courseService.Add(form).subscribe(
                  () => {
                    this.dialogRef.close(form);
                    this.snackBar.OpenSnackBar(
                      this.translate.get("success.registration"),
                      "ok",
                      5000,
                      SoundEnum.beep
                    );
                  },
                  err => {
                    // this.errObject = this.errorService.getError(err);
                    // this.param = this.errorService.objectError(this.errObject);
                    // this.errors = this.errorService.returnError(err);
                    this.errorList = this.errorService.getErrorList(err.error);
                  }
                );
              }
            });
        }
      }
    );
  }


  onNoClick(): void {
    this.dialogRef.close();
  }


}
